module.exports = __webpack_public_path__ + "static/mapa-478466f72cf7c311ab47b6e3f0feb3b8.svg";